module.exports = __webpack_public_path__ + "statics/img/start-page-bg-055637d4.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/xhpopulrz/download/start-page-bg.png
// module id = 1212
// module chunks = 143